/* ===========================================================================
   Animaciones aprobadas (24-09)
   ---------------------------------------------------------------------------
   Titles word by word, text that lights up while reading, card text fading
   in after the card, images that open while scrolling, black and white to
   colour. Each one only runs when its class is on <body> (see the layout)
   or its data attribute is on the section. Loaded after clara.js and before
   lurea.js, so the DOM is ready before GSAP looks at it.

   Anything already on screen when the page loads is left alone: hiding it
   and bringing it back would read as a flicker, not as an entrance.
   ========================================================================= */

(function () {
  "use strict";

  var body = document.body;
  if (body.classList.contains("clara-editor") || (window.Shopify && window.Shopify.designMode)) return;

  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var on = function (c) { return body.classList.contains(c); };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var vh = function () { return window.innerHeight || document.documentElement.clientHeight; };
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var below = function (el, k) { return el.getBoundingClientRect().top > vh() * (k || 0.92); };
  var hasIO = "IntersectionObserver" in window;

  // Wraps every word of el in make(word, index), keeping links, <strong>, <br>…
  function eachWord(el, make) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var texts = [], n = 0;
    while (walker.nextNode()) texts.push(walker.currentNode);
    texts.forEach(function (t) {
      if (!t.nodeValue.trim()) return;
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(part));
        else frag.appendChild(make(part, n++));
      });
      t.parentNode.replaceChild(frag, t);
    });
    return n;
  }

  /* ------------------------------------------------ 8 · titles ---------- */

  if (on("anim-titles") && hasIO) {
    var heads = $$("main h1.dsp, main h2.dsp, main .lti__h, main .lct__h, main .cbn__h, main .col__h").filter(function (h) {
      return !h.hasAttribute("data-words") &&
        !h.closest(".hero, .crs, .pdp, [data-no-anim]") &&
        !h.querySelector(".aw, .mk, .w") &&
        h.textContent.trim() &&
        below(h);
    });
    if (heads.length) {
      var hio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add("aw-in");
          hio.unobserve(e.target);
        });
      }, { rootMargin: "0px 0px -12% 0px" });
      heads.forEach(function (h) {
        eachWord(h, function (w, i) {
          var outer = document.createElement("span");
          var inner = document.createElement("span");
          outer.className = "aw";
          inner.className = "aw__i";
          inner.style.setProperty("--i", Math.min(i, 12));
          inner.textContent = w;
          outer.appendChild(inner);
          return outer;
        });
        hio.observe(h);
      });
    }
  }

  /* ----------------------------------- 10 · card text after the card ---- */

  if (on("anim-fx")) {
    $$(".card").forEach(function (card) {
      var row = card.parentElement ? [].indexOf.call(card.parentElement.children, card) : 0;
      card.style.setProperty("--c", row % 4);
      $$(".card__info > *", card).forEach(function (x, k) { x.style.setProperty("--k", Math.min(k, 4)); });
    });
  }

  /* ---------------------------------------- scroll-linked effects ------- */

  var frames = [];
  if (!on("anim-scroll") || reduce) return;

  // 9 · words light up from 25 % to full as the text passes
  $$("[data-read]").forEach(function (el) {
    if (!below(el, 0.85)) return;
    var words = [];
    eachWord(el, function (w) {
      var s = document.createElement("span");
      s.className = "rd-w";
      s.textContent = w;
      words.push(s);
      return s;
    });
    if (!words.length) return;
    var last = -1;
    frames.push(function () {
      var r = el.getBoundingClientRect(), h = vh();
      var p = clamp((h * 0.85 - r.top) / (r.height + h * 0.4));
      p = Math.round(p * 500) / 500;
      if (p === last) return;
      last = p;
      var n = words.length;
      for (var i = 0; i < n; i++) {
        var k = clamp(p * n * 1.15 - i);
        words[i].style.opacity = k >= 1 ? "1" : (0.25 + 0.75 * k).toFixed(3);
      }
    });
  });

  // 12 · black and white to colour: a colour copy on top fades in
  function colourCopy(box) {
    var img = box.querySelector("img");
    if (!img) return null;
    var src = img.parentNode.tagName === "PICTURE" ? img.parentNode : img;
    var copy = src.cloneNode(true);
    var cimg = copy.tagName === "IMG" ? copy : copy.querySelector("img");
    if (!cimg) return null;
    cimg.alt = "";
    cimg.setAttribute("aria-hidden", "true");
    cimg.removeAttribute("fetchpriority");
    cimg.removeAttribute("id");
    cimg.classList.add("bw-c");
    if (getComputedStyle(box).position === "static") box.style.position = "relative";
    src.parentNode.insertBefore(copy, src.nextSibling);
    img.classList.add("bw-g");
    function place() {
      var cs = getComputedStyle(img);
      var st = cimg.style;
      st.position = "absolute";
      st.margin = "0";
      st.maxWidth = "none";
      st.maxHeight = "none";
      st.aspectRatio = "auto";
      st.left = img.offsetLeft + "px";
      st.top = img.offsetTop + "px";
      st.width = img.offsetWidth + "px";
      st.height = img.offsetHeight + "px";
      st.objectFit = cs.objectFit;
      st.objectPosition = cs.objectPosition;
    }
    place();
    img.addEventListener("load", place);
    if ("ResizeObserver" in window) new ResizeObserver(place).observe(img);
    else window.addEventListener("resize", place);
    return cimg;
  }

  $$("[data-bw]").forEach(function (box) {
    if (!below(box)) return;
    var paint;
    if (box.classList.contains("camp--bw")) {
      paint = function (p) { box.style.setProperty("--bw", p.toFixed(3)); };
    } else {
      var cimg = colourCopy(box);
      if (!cimg) return;
      paint = function (p) { cimg.style.opacity = p.toFixed(3); };
    }
    var last = -1;
    frames.push(function () {
      var r = box.getBoundingClientRect(), h = vh();
      var p = Math.min(1, clamp((h * 0.95 - r.top) / (r.height + h * 0.15)) * 1.25);
      p = Math.round(p * 500) / 500;
      if (p === last) return;
      last = p;
      paint(p);
    });
  });

  // 11 · the image starts slightly gathered and opens to full size
  if (on("anim-open")) {
    $$("[data-reveal-img]").forEach(function (box) {
      if (!below(box)) return;
      var last = -1;
      frames.push(function () {
        var r = box.getBoundingClientRect(), h = vh();
        var p = clamp((h - r.top) / ((h + r.height) / 2));
        p = Math.round(p * 1000) / 1000;
        if (p === last) return;
        last = p;
        box.style.clipPath = p >= 1 ? "" : "inset(" + (10 * (1 - p)).toFixed(2) + "% " + (14 * (1 - p)).toFixed(2) + "%)";
        var s = p >= 1 ? "" : "scale(" + (1.12 - 0.12 * p).toFixed(4) + ")";
        $$("img", box).forEach(function (im) { im.style.transform = s; });
      });
    });
  }

  if (!frames.length) return;
  var ticking = false;
  function frame() {
    ticking = false;
    for (var i = 0; i < frames.length; i++) frames[i]();
  }
  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }
  window.addEventListener("scroll", request, { passive: true });
  window.addEventListener("resize", request);
  window.addEventListener("load", request);
  frame();
})();
